import { createSelector, createStructuredSelector } from "reselect"

export const selectAttachmentState = state => state.attachment

export const makeAttachmentStateSelector = key =>
    createSelector(
        selectAttachmentState,
        state => state.get(key)
    )

const attachment = makeAttachmentStateSelector("attachment")

export const makeAttachmentSelector = key => createSelector(
    attachment,
    attachment => attachment.get(key)
)

export const makeAttachmentToJSSelector = key => createSelector(
    attachment,
    attachment => attachment.get(key)
)

export const attachmentFormSelectors = createStructuredSelector({
    is_public: makeAttachmentSelector("is_public"),
    name: makeAttachmentSelector("name"),
    shortDescription: makeAttachmentSelector("short_description"),
})
